import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '../../Icon';
import Theme from '../../Theme';
import { Title, HeaderButton } from './elements';
/**
 * Header
 *
 * This component is in charge of displaying date picker header.
 *
 * @param {string} className - Class needed by styled component.
 * @param {string} title - The title of the header.
 * @param {func} prev - Prev button handler.
 * @param {func} next - Next button handler.
 * @param {bool} disablePrev - Indicates if the prev button should be disabled.
 * @param {bool} disableNext - Indicates if the next button should be disabled.
 * @param {number} monthIndex - Month index ( rely on numberOfMonthsToDisplay).
 *
 * @return {jsx}
 */

var Header = function Header(_ref) {
  var className = _ref.className,
      title = _ref.title,
      prev = _ref.prev,
      next = _ref.next,
      disablePrev = _ref.disablePrev,
      disableNext = _ref.disableNext,
      monthIndex = _ref.monthIndex;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(HeaderButton, {
    "data-testid": "previous-month-button",
    size: "small",
    onClick: function onClick() {
      return prev(monthIndex);
    },
    disabled: disablePrev
  }, /*#__PURE__*/React.createElement(Icon, {
    color: Theme.palette.spaceGrey,
    name: "chevron-left"
  })), /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(HeaderButton, {
    "data-testid": "next-month-button",
    size: "small",
    onClick: function onClick() {
      return next(monthIndex);
    },
    disabled: disableNext
  }, /*#__PURE__*/React.createElement(Icon, {
    color: Theme.palette.spaceGrey,
    name: "chevron-right"
  })));
};
/**
 * PropTypes Validation.
 */


var bool = PropTypes.bool,
    func = PropTypes.func,
    number = PropTypes.number,
    string = PropTypes.string;
Header.propTypes = {
  className: string,
  title: string,
  prev: func,
  monthIndex: number,
  next: func,
  disablePrev: bool,
  disableNext: bool
};
/**
 * Default props.
 */

Header.defaultProps = {
  className: '',
  title: '',
  prev: function prev() {},
  monthIndex: 0,
  next: function next() {},
  disablePrev: false,
  disableNext: false
};
var styledHeader = styled(Header).withConfig({
  displayName: "Header__styledHeader",
  componentId: "s7ah7d-0"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;color:", ";text-align:center;font-size:", ";line-height:", ";"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.darkBlue;
}, function (_ref3) {
  var size = _ref3.theme.fonts.size;
  return size["default"];
}, function (_ref4) {
  var size = _ref4.theme.fonts.size;
  return size.medium;
});
styledHeader.displayName = 'Header';
export default memo(styledHeader);